/*
 * @Author: lizhigang
 * @Date: 2025-12-08
 * @Company: www.smm.cn
 * @Description: SignIn 工具函数
 */

import http from "@repo/ui/utils"

import { getCookie } from "./actions"
import { COOKIE_DEFAULT_KEY } from "./const"

/**
 * 是否移动端
 */
export const isMobile = () => {
  if (typeof window !== "undefined") {
    const ua = navigator.userAgent.toLowerCase()
    return /iphone|ipod|ipad|android|mobile|blackberry|iemobile|opera mini|mobi/i.test(ua)
  }
  return false
}

/**
 * 发送位置信息到服务器
 * @param locale - 当前语言
 * @param cb - 完成后的回调函数
 */
export const sendLatLng = async (locale: string, cb?: () => void) => {
  const SMM_location = await getCookie("SMM_location")
  const token = await getCookie(COOKIE_DEFAULT_KEY)
  let location: any = {}
  let auth_token: string = ""

  if (SMM_location) {
    location = JSON.parse(decodeURIComponent(SMM_location || ""))
  } else {
    cb?.()
    return
  }

  if (token) {
    auth_token = token
  } else {
    cb?.()
    return
  }

  if (location) {
    const lat_lng = `${location.latitude},${location.longitude}`

    const formData = new FormData()
    formData.append("device_type", "en")
    formData.append("lat_lng", lat_lng)
    formData.append("auth_token", auth_token)
    await http.post(`/usercenter/4.0/start_app`, {
      params: formData,
      showOriginResponse: true,
      getLang: () => locale,
    })
    console.log("sendLatLng success")
  } else {
    console.log("sendLatLng failed:location does no exist")
  }
  cb?.()
}
